module.exports = __webpack_public_path__ + "static/media/leader.f7c5aa24.png";